import { gql } from '@apollo/client'

export const locationResultFragment = gql`
  fragment locationResult on LocationResult {
    id
    slug
    name
    cityName
    country {
      code
    }
  }
`
